import { Modal } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

import { CloseButtonContainer, ModalCloseButton } from './ModalCloseButton';

const ModalBack = styled.div<{ $width?: string }>`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  width: ${p => p.$width ?? '860px'};
  max-width: 95%;
  height: 95%;
  max-height: fit-content;
  padding: ${p => (p.theme.isMobile ? '40px 20px' : '40px 80px')};
  box-sizing: border-box;
  background: white;
  border-radius: 4px;
  overflow: auto;
  &:focus {
    outline: none;
  }
`;

export const ModalTextContainer = styled.div`
  margin: 0px;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
  word-break: keep-all;
`;

interface WideModalProps {
  open: boolean;
  onClose: () => void;
  width?: string;
}
export const WideModal = (props: WideModalProps & PropsWithChildren) => {
  const { open, onClose, width, children } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <ModalBack $width={width}>
        <CloseButtonContainer>
          <ModalCloseButton onClick={onClose} />
        </CloseButtonContainer>
        {children}
      </ModalBack>
    </Modal>
  );
};
